const EmojisSheetContent = ({url, emoji, imageClicked, emojiClicked}) => {

    return ( 
    <div className="emojiscontent" style={{caretColor:"transparent"}}>
        {url ?
            <img src={url} alt="emoji" style={{width:"3em",height:"3em",objectFit:"contain",cursor:"pointer"}}
            onClick={()=>imageClicked(url)}
            />
            :
            <h1 onClick={()=>emojiClicked(emoji)} style={{cursor:"pointer"}}>{emoji}</h1>
        }
     
    </div> 
    );
}
export default EmojisSheetContent;